<template>
  <section class="shop-default-hero">
    <div class="shop-default-hero__content">
      <div class="shop-default-hero__title">INE Shop</div>
      <div class="shop-default-hero__details">
        Ready to learn with INE? Discover content across Networking, Cybersecurity, Cloud Computing,
        and Data Science for IT professionals at every level.
      </div>
      <div class="shop-default-hero__why-ine">Why INE? Affordable | Hands-On | Continuous</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ShopDefaultHeroSection',
}
</script>

<style lang="scss" scoped>
.shop-default-hero {
  display: none;
  @include desktop {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto 130px auto;
    color: var(--white);
    font-family: var(--font-regular);
    display: flex;
  }
  @include lg-desktop {
    min-height: 600px;
    margin-bottom: 0;
    align-items: center;
  }
  &__content {
    width: 50%;
  }
  &__title {
    font-size: rem(54px);
    line-height: rem(66px);
    font-style: normal;
    font-weight: 700;
    margin-bottom: 30px;
  }
  &__details {
    color: var(--light-blue-gray);
    font-size: rem(24px);
    line-height: rem(32px);
    font-style: normal;
    font-weight: 450;
    margin-bottom: 30px;
  }
  &__why-ine {
    font-size: rem(24px);
    line-height: rem(32px);
    font-style: normal;
    font-weight: 700;
  }
}
</style>
